import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Banknote } from 'lucide-react';

export const LifetimeBalances = ({ balances, fmt }) => (
  <Card className="bg-white border border-[#D1D1CD] rounded-lg shadow-sm" data-testid="lifetime-balance-card">
    <CardHeader>
      <CardTitle className="text-lg font-semibold text-[#1C1C1E] flex items-center gap-2">
        <Banknote className="w-5 h-5 text-[#2E4632]" />
        Lifetime Balance Due
        <span className="text-sm font-normal text-[#5C5C5C] ml-2">
          (all-time, not limited to the selected period)
        </span>
      </CardTitle>
    </CardHeader>
    <CardContent>
      {balances.length === 0 ? (
        <p className="text-[#5C5C5C] text-sm">No active workers yet</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {balances.map((b) => (
            <div
              key={b.worker_id}
              data-testid={`lifetime-balance-${b.worker_id}`}
              className={`rounded-lg p-3 border ${
                b.net_balance < 0
                  ? 'bg-[#BC4749]/5 border-[#BC4749]/20'
                  : 'bg-[#2E4632]/5 border-[#2E4632]/20'
              }`}
            >
              <p className="text-sm font-medium text-[#1C1C1E] truncate">{b.worker_name}</p>
              <p className={`text-xl font-bold mt-1 ${b.net_balance < 0 ? 'text-[#BC4749]' : 'text-[#2E4632]'}`} style={{ fontFamily: 'Manrope, sans-serif' }}>
                {fmt(b.net_balance)}
              </p>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
